// src/supabaseClient.js
import { createClient } from "@supabase/supabase-js";

const SUPABASE_URL = "https://iabdippnknqmozheiulb.supabase.co"; // Ersetze durch deine URL
const SUPABASE_KEY =
  "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImlhYmRpcHBua25xbW96aGVpdWxiIiwicm9sZSI6ImFub24iLCJpYXQiOjE3MzIwNDExNzQsImV4cCI6MjA0NzYxNzE3NH0.KfZR5YVwVQcrbToe9NzdUvJD8jbkeKOq8DRlM87F0Js"; // Ersetze durch deinen PUBLIC_KEY

export const supabase = createClient(SUPABASE_URL, SUPABASE_KEY);
